export function isEmbedded(): boolean {
  const w = window as any
  return !!w.DESIGNER_EMBEDDED && (!!w.DESIGNER_BOOTSTRAP || !!w.DESIGNER_MOUNT)
}
